export const photoWidthPx = '115px';
export const collapseWidthPx = '83px';
export const assetTypeWidthPercent = '25%';
export const representationWidthPercent = '17%';

export const rowData: Array<any> = [{
    title: 'File Name',
    width: `calc(100% - ${photoWidthPx} - ${collapseWidthPx} - ${assetTypeWidthPercent} - ${representationWidthPercent})`,
    fontRegular: true,
    item_name: 'filename',
  }, {
    title: 'Asset type',
    width: assetTypeWidthPercent,
    control: true,
    item_name: 'asset_type',
  }, {
    title: 'Representation',
    width: representationWidthPercent,
    control: true,
    item_name: 'representation',
  },
];

export const pagRowData: Array<any> = [{
    title: 'File Name',
    width: `calc(100% - ${collapseWidthPx} - ${assetTypeWidthPercent} - ${representationWidthPercent})`,
    fontRegular: true,
    item_name: 'filename',
  }, {
    title: 'URL',
    width: `calc(${assetTypeWidthPercent} + ${representationWidthPercent})`,
    control: true,
    item_name: 'file_path',
  }
];
